import { CostsData } from "./useCostsData";
import cropr from "../../../shared/utils/cropr";

export function aggregateData(costsData: CostsData) {
  return costsData.data.map((e) => {
    const mDay = e.mDate;
    return {
      name:
        costsData.aggregate === "day"
          ? cropr.dayToStr(mDay.day())
          : costsData.aggregate === "week"
          ? mDay.week()
          : cropr.monthToStr(mDay.month()),
      costs: Math.round(e.costs),
    };
  });
}
